import { render, staticRenderFns } from "./2FA.vue?vue&type=template&id=8b84f948"
import script from "./2FA.vue?vue&type=script&lang=js"
export * from "./2FA.vue?vue&type=script&lang=js"
import style0 from "./2FA.vue?vue&type=style&index=0&id=8b84f948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports